import React, { useState, useEffect, useRef } from 'react';
import { MDBContainer } from 'mdb-react-ui-kit';
import BillsTable from "./BillsTable/BillsTable";
import PreHeader from "./PreHeader";
import Filter from './Filter/Filter';
import AppBuildVersion from "../AppBuildVersion/AppBuildVersion";
import axios from "axios";
import ListAndNotificatonModal from './ListsAndNotificationModal/ListAndNotificatonModal';
import SaveFilterModal from './Filter/SaveFilterModal/SaveFilterModal';


function Home() {
    const [container, setContainer] = useState();
    const sidenavContent = useRef(null);
    const [sideNavToggle, setSideNavToggle] = useState(false);
    const [sessionId, setSessionId ] = useState();
    const [activeSessionInfo, setActiveSessionInfo ] = useState([]);
    const [sessionInfoForHeader, setSessionInfoForHeader] = useState("Loading...");
    const [legislatureId, setLegislatureId] = useState();
    const [offset, setOffset] = useState(0);
    const [subjectCode, setSubjectCode] = useState([]);
    const [selectedBillTypes, setSelectedBillTypes] = useState([]);
    const [selectedLegislator, setSelectedLegislator] = useState("");
    const [selectedDrafter, setSelectedDrafter] = useState("");
    const [selectedParties, setSelectedParties] = useState([]);
    const [selectedChambers, setSelectedChambers] = useState([]);
    const [selectedCommittee, setSelectedCommitte] = useState("");
    const [selectedProgress, setSelectedProgress] = useState("");
    const [hasAmendment, setHasAmendment] = useState(false);
    const [hasFiscalNotes, setHasFiscalNotes] = useState(false);
    const [hasLegalNotes, setHasLegalNotes] = useState(false);
    const [hasPreIntroductionRequired, setHasPreIntroductionRequired] = useState(false);
    const [selectedDeadlines, setSelectedDeadlines] = useState([]);
    const [selectedActionTypes, setSelectedActionTypes]  =  useState([]);
    const [statusStartDate, setStatusStartDate] = useState(false);
    const [statusEndDate, setStatusEndDate] = useState(false);
    const [requestor, setRequestor ] = useState(false);
    const [requestorType, setRequestorType] = useState(false);
    const [byRequestOf, setByRequestOf] = useState(false);
    const [byRequestOfType, setByRequestOfType] = useState(false);

    // ** Chapters are fetched from the search api response in bills table ** //
    // ** This is same approach as Counts for now ** //
    const [chaptersCount, setChaptersCount] = useState(false);
    const [selectedChapters, setSelectedChapters] = useState([]);
    // ** Counts ** //
    const [ chambersCount, setChambersCount ] = useState(false);
    const [ billTypesCount, setBillTypesCount ] = useState(false);
    const [ partyCount, setPartyCount ] = useState(false);
    const [ deadlineCategoriesCount, setDealineCategoriesCount ] = useState(false);

    const [isLoading, setIsLoading] = useState(true);

    // ** POPUP MODALS **//
    const [showListAndNotificationUI, setShowListAndNotificationUI] = useState(false);
    const [showSaveFilterModal, setShowSaveFilterModal] = useState(false);

    useEffect(() => {
        const fetchActiveSession = async () => {

            try {
                const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/activeSessions/getActiveSession`);
                const sessionResponse = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/sessions/${response.data.sessionId}`);
                setSessionId(sessionResponse.data.id);
                setLegislatureId(sessionResponse.data.legislature.id);
                setActiveSessionInfo(sessionResponse.data);
            } catch (error) {
                console.error('Error fetching active session data:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchActiveSession();
    }, []);

    useEffect(() => {
        setContainer(sidenavContent.current);
    }, [sessionId]);

    useEffect(() => {
        setSelectedLegislator("");
        setSelectedDrafter("");
    }, [sessionId]);


    if (sidenavContent.current) {
        sidenavContent.current.style.marginLeft = sideNavToggle ? '100px' : '0px';
    }

    useEffect(() => {
        setSessionInfoForHeader(`${new Date(activeSessionInfo.startDate).getFullYear().toString()} (${activeSessionInfo.type})`)
    }, [activeSessionInfo])


    return (
        <>
            <Filter
                activeSessionInfo={activeSessionInfo}
                sideNavToggle={sideNavToggle}
                setSideNavToggle={setSideNavToggle}
                container={container}
                setSessionId={setSessionId}
                sessionInfoForHeader={sessionInfoForHeader}
                setSessionInfoForHeader={setSessionInfoForHeader}
                setLegislatureId={setLegislatureId}
                setSubjectCode={setSubjectCode}
                sessionId={sessionId}
                legislatureId={legislatureId}
                selectedBillTypes={selectedBillTypes}
                setSelectedBillTypes={setSelectedBillTypes}
                selectedLegislator={selectedLegislator}
                setSelectedLegislator={setSelectedLegislator}
                selectedDrafter={selectedDrafter}
                selectedDeadlines={selectedDeadlines}
                setSelectedDrafter={setSelectedDrafter}
                setSelectedProgress={setSelectedProgress}
                setOffset={setOffset}
                selectedParties={selectedParties}
                setSelectedParties={setSelectedParties}
                selectedChambers={selectedChambers}
                setSelectedChambers={setSelectedChambers}
                selectedCommittee={selectedCommittee}
                setSelectedCommitte={setSelectedCommitte}
                setSelectedDeadlines={setSelectedDeadlines}
                chambersCount={chambersCount}
                billTypesCount={billTypesCount}
                partyCount={partyCount}
                hasAmendment={hasAmendment}
                hasFiscalNotes={hasFiscalNotes}
                hasLegalNotes={hasLegalNotes}
                setHasAmendment={setHasAmendment}
                setHasFiscalNotes={setHasFiscalNotes}
                setHasLegalNotes={setHasLegalNotes}
                deadlineCategoriesCount={deadlineCategoriesCount}
                subjectCode={subjectCode}
                selectedProgress={selectedProgress}
                selectedActionTypes={selectedActionTypes}
                setSelectedActionTypes={setSelectedActionTypes}
                statusStartDate={statusStartDate}
                setStatusStartDate={setStatusStartDate}
                statusEndDate={statusEndDate}
                setStatusEndDate={setStatusEndDate}
                chaptersCount={chaptersCount}
                setChaptersCount={setChaptersCount}
                selectedChapters={selectedChapters}
                setSelectedChapters={setSelectedChapters}
                setHasPreIntroductionRequired={setHasPreIntroductionRequired}
                hasPreIntroductionRequired={hasPreIntroductionRequired}
                requestor={requestor}
                setRequestor={setRequestor}
                requestorType={requestorType}
                setRequestorType={setRequestorType}
                byRequestOf={byRequestOf}
                setByRequestOf={setByRequestOf}
                byRequestOfType={byRequestOfType}
                setByRequestOfType={setByRequestOfType}
                showSaveFilterModal={showSaveFilterModal}
                setShowSaveFilterModal={setShowSaveFilterModal}
            />
            <PreHeader
                showListAndNotificationUI={showListAndNotificationUI}
                setShowListAndNotificationUI={setShowListAndNotificationUI}
            />
            <MDBContainer fluid>
                <ListAndNotificatonModal
                    showListAndNotificationUI={showListAndNotificationUI}
                    setShowListAndNotificationUI={setShowListAndNotificationUI}
                />
                <SaveFilterModal
                    showSaveFilterModal={showSaveFilterModal}
                    setShowSaveFilterModal={setShowSaveFilterModal}
                />
                <div ref={sidenavContent}>
                    {isLoading ? (
                        <div>Loading...</div>
                    ) : sessionId ? (

                        <BillsTable
                            sessionId={sessionId}
                            legislatureId={legislatureId}
                            selectedBillTypes={selectedBillTypes}
                            selectedLegislator={selectedLegislator}
                            selectedDrafter={selectedDrafter}
                            selectedParties={selectedParties}
                            selectedChambers={selectedChambers}
                            selectedCommittee={selectedCommittee}
                            selectedProgress={selectedProgress}
                            selectedDeadlines={selectedDeadlines}
                            selectedActionTypes={selectedActionTypes}
                            hasAmendment={hasAmendment}
                            hasFiscalNotes={hasFiscalNotes}
                            hasLegalNotes={hasLegalNotes}
                            hasPreIntroductionRequired={hasPreIntroductionRequired}
                            subjectCode={subjectCode}
                            setSideNavToggle={setSideNavToggle}
                            sideNavToggle={sideNavToggle}
                            offset={offset}
                            setOffset={setOffset}
                            setChambersCount={setChambersCount}
                            setBillTypesCount={setBillTypesCount}
                            setPartyCount={setPartyCount}
                            setDealineCategoriesCount={setDealineCategoriesCount}
                            statusStartDate={statusStartDate}
                            statusEndDate={statusEndDate}
                            chaptersCount={chaptersCount}
                            setChaptersCount={setChaptersCount}
                            selectedChapters={selectedChapters}
                            setSelectedChapters={setSelectedChapters}
                            sessionInfoForHeader={sessionInfoForHeader}
                            requestor={requestor}
                            requestorType={requestorType}
                            byRequestOf={byRequestOf}
                            byRequestOfType={byRequestOfType}
                        />
                    ) : (
                        <div>Error: Unable to load session data</div>
                    )}
                    <AppBuildVersion />
                </div>
            </MDBContainer>
        </>
    );
}

export default Home;